// import React, { useState } from 'react';
// import { Table, Spinner, Form, Row, Col, Button, Alert, Badge, CardFooter, CardTitle } from 'react-bootstrap';
// import 'react-datepicker/dist/react-datepicker.css';
// import { Card, CardBody, CardHeader } from '@components/card/card';
// import { ntxAPI } from '@API/axiosNeatex';
// import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import type { APIResponse } from '@store/Shared/shared';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
// import { TreeSelect } from 'antd';
// import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
// import Loading from '@components/Shared/Loader/Loading';

// interface StockBalance {
//   itemId: string;
//   itemCode: string;
//   itemName: string;
//   itemName2: string;
//   inventoryId: string;
//   inventoryName: string;
//   inventoryName2: string;
//   subinventoryId: string;
//   subinventoryName: string;
//   subinventoryName2: string;
//   uom: string;
//   uomName: string;
//   uomName2: string;
//   uomCode: string;
//   lotId: string | null;
//   lotNumber: string | null;
//   lotExpirationDate: string | null;
//   qty: number;
// }

// const StockBalanceReport: React.FC = () => {
//   const [data, setData] = useState<StockBalance[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   const { ItemsOptions, loading: loading1, error: error1 } = useGetItemsList();
//   const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
//   const { TreeSubInventoryData, loading: loading3, error: error3 } = useGetSubinventoryList();
//   const { t, i18n } = useTranslation();

//   // Filter states

//   const [itemId, setItemId] = useState<string | null>('');
//   const [inventoryId, setInventoryId] = useState<string | null>('');
//   const [subInventoryId, setSubInventoryId] = useState<string | null>('');

//   const [showZeroBalance, setShowZeroBalance] = useState<boolean>(false);

//   const fetchData = async () => {
//     if (!itemId) {
//       setError(t('ItemRequired'));
//       return;
//     }
//     setLoading(true);
//     setError(null);
//     try {
//       const { data } = await ntxAPI.get<APIResponse<StockBalance[]>>(`InventoryReports/GetStockBalance`, {
//         params: {
//           ItemId: itemId,
//           InventoryId: inventoryId,
//           SubinventoryId: subInventoryId
//         }
//       });

//       if (data.succeeded === true) {
//         setData(data.data);
//       } else {
//         setError(data instanceof Error ? data.message : t('UnknownError'));
//       }
//     } catch (err) {
//       setError(err instanceof Error ? err.message : t('UnknownError'));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetFilters = () => {
//     setItemId(null);
//     setInventoryId(null);
//     setSubInventoryId(null);
//   };

//   const formatQuantity = (quantity: number): string => {
//     return new Intl.NumberFormat('en-US').format(quantity);
//   };

//   // Filter data based on zero balance toggle
//   const filteredData = showZeroBalance ? data : data.filter(item => item.qty > 0);

//   return (
//     <div className='container mt-4'>
//       <Card>
//         <CardHeader className='d-flex justify-content-between align-items-center'>
//           <h5 className='mb-0'>Stock Balance Report</h5>
//           {data.length > 0 && (
//             <div>
//               <span className='me-2'>
//                 Showing: {filteredData.length} of {data.length} items
//               </span>
//             </div>
//           )}
//         </CardHeader>

//         <CardBody>
//           {error && (
//             <Alert variant='danger' className='mb-4'>
//               Error loading data: {error}
//             </Alert>
//           )}

//           {/* Filters Section */}
//           <Card className='mb-4'>
//             <CardHeader>Filters</CardHeader>
//             <Loading loading={loading1 || loading2 || loading3} error={error1 || error2 || error3}>
//               <CardBody>
//                 <Form>
//                   <Row className='g-3'>
//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('itemName')}</Form.Label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isSearchable
//                           isClearable
//                           options={ItemsOptions}
//                           onChange={(option: any) => setItemId(option?.value || null)}
//                           value={ItemsOptions.find(f => f.value === itemId)}
//                           placeholder={t('Choose')}
//                           menuPortalTarget={document.body}
//                           styles={{
//                             menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                           }}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('Inventory')}</Form.Label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isSearchable={true}
//                           isClearable
//                           options={InventoryOptions}
//                           onChange={(option: any) => {
//                             setInventoryId(option === null ? null : option.value);
//                             setSubInventoryId(null);
//                           }}
//                           placeholder={t('Choose')}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('SubInventory')}</Form.Label>
//                         <TreeSelect
//                           loading={loading3}
//                           showSearch
//                           className='w-100'
//                           treeLine
//                           placeholder={t('Choose')}
//                           allowClear
//                           treeDefaultExpandAll={false}
//                           value={subInventoryId}
//                           onChange={(option: any) => {
//                             setSubInventoryId(option === null ? null : option);
//                           }}
//                           treeData={TreeSubInventoryData?.filter(f => f.parentId === inventoryId)}
//                           treeNodeFilterProp='title'
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group controlId='zeroBalanceFilter'>
//                         <Form.Label>Show Zero Balance</Form.Label>
//                         <Form.Check
//                           type='switch'
//                           checked={showZeroBalance}
//                           onChange={e => setShowZeroBalance(e.target.checked)}
//                           label={showZeroBalance ? 'Showing all' : 'Hiding zero balance'}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col xs={12} className='text-end'>
//                       <Button variant='secondary' onClick={resetFilters} className='me-2'>
//                         Reset Filters
//                       </Button>
//                       <Button variant='primary' onClick={fetchData} disabled={loading}>
//                         {loading ? (
//                           <>
//                             <Spinner
//                               as='span'
//                               animation='border'
//                               size='sm'
//                               role='status'
//                               aria-hidden='true'
//                               className='me-2'
//                             />
//                             Loading...
//                           </>
//                         ) : (
//                           'Load Report'
//                         )}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Form>
//               </CardBody>
//             </Loading>
//           </Card>

//           {/* Summary Cards */}
//           {data.length > 0 && (
//             <Row className='mb-4'>
//               <Col md={3}>
//                 <Card className='text-center'>
//                   <CardBody>
//                     <CardTitle>Total Items</CardTitle>
//                     <h3 className='text-primary'>{data.length}</h3>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={3}>
//                 <Card className='text-center'>
//                   <CardBody>
//                     <CardTitle>In Stock Items</CardTitle>
//                     <h3 className='text-success'>{data.filter(item => item.qty > 0).length}</h3>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={3}>
//                 <Card className='text-center'>
//                   <CardBody>
//                     <CardTitle>Out of Stock</CardTitle>
//                     <h3 className='text-danger'>{data.filter(item => item.qty === 0).length}</h3>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={3}>
//                 <Card className='text-center'>
//                   <CardBody>
//                     <CardTitle>Total Quantity</CardTitle>
//                     <h3 className='text-info'>{formatQuantity(data.reduce((sum, item) => sum + item.qty, 0))}</h3>
//                   </CardBody>
//                 </Card>
//               </Col>
//             </Row>
//           )}

//           {/* Results Section */}
//           {loading ? (
//             <div className='text-center my-5'>
//               <Spinner animation='border' role='status'>
//                 <span className='visually-hidden'>Loading...</span>
//               </Spinner>
//               <p className='mt-2'>Loading stock balance data...</p>
//             </div>
//           ) : filteredData.length > 0 ? (
//             <div className='table-responsive'>
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>Item Code</th>
//                     <th>Item Name</th>
//                     <th>Inventory</th>
//                     <th>Subinventory</th>
//                     <th>UOM</th>
//                     <th>Lot Number</th>
//                     <th>Expiration Date</th>
//                     <th>Quantity</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredData.map((item, index) => (
//                     <tr key={`${item.itemId}-${item.inventoryId}-${item.subinventoryId}-${index}`}>
//                       <td>{item.itemCode}</td>
//                       <td>
//                         <div>{item.itemName}</div>
//                         {item.itemName2 && <div className='text-muted small'>{item.itemName2}</div>}
//                       </td>
//                       <td>
//                         <div>{item.inventoryName}</div>
//                         {item.inventoryName2 && <div className='text-muted small'>{item.inventoryName2}</div>}
//                       </td>
//                       <td>
//                         <div>{item.subinventoryName}</div>
//                         {item.subinventoryName2 && <div className='text-muted small'>{item.subinventoryName2}</div>}
//                       </td>
//                       <td>
//                         <div>{item.uomName}</div>
//                         {item.uomName2 && <div className='text-muted small'>{item.uomName2}</div>}
//                         <div className='text-muted small'>({item.uomCode})</div>
//                       </td>
//                       <td>{item.lotNumber || '-'}</td>
//                       <td>{item.lotExpirationDate}</td>
//                       <td className={`fw-bold ${item.qty > 0 ? 'text-success' : 'text-danger'}`}>
//                         {formatQuantity(item.qty)}
//                       </td>
//                       <td>
//                         <Badge bg={item.qty > 0 ? 'success' : 'danger'}>
//                           {item.qty > 0 ? 'In Stock' : 'Out of Stock'}
//                         </Badge>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           ) : (
//             <div className='text-center py-5'>
//               <p>No data available. Set your filters and click "Load Report" to generate.</p>
//             </div>
//           )}
//         </CardBody>

//         {data.length > 0 && (
//           <CardFooter className='text-muted'>Report generated on {new Date().toLocaleString()}</CardFooter>
//         )}
//       </Card>
//     </div>
//   );
// };

// export default StockBalanceReport;

import React, { useState } from 'react';
import { Table, Spinner, Form, Row, Col, Button, Alert, Badge, CardFooter, CardTitle } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { Card, CardBody, CardHeader } from '@components/card/card';
import { ntxAPI } from '@API/axiosNeatex';
import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import type { APIResponse } from '@store/Shared/shared';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import { TreeSelect } from 'antd';
import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
import Loading from '@components/Shared/Loader/Loading';

interface StockBalance {
  itemId: string;
  itemCode: string;
  itemName: string;
  itemName2: string;
  inventoryId: string;
  inventoryName: string;
  inventoryName2: string;
  subinventoryId: string;
  subinventoryName: string;
  subinventoryName2: string;
  uom: string;
  uomName: string;
  uomName2: string;
  uomCode: string;
  lotId: string | null;
  lotNumber: string | null;
  lotExpirationDate: string | null;
  qty: number;
}

const StockBalanceReport: React.FC = () => {
  const [data, setData] = useState<StockBalance[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { ItemsOptions, loading: loading1, error: error1 } = useGetItemsList();
  const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
  const { TreeSubInventoryData, loading: loading3, error: error3 } = useGetSubinventoryList();
  const { t, i18n } = useTranslation();

  // Filter states
  const [itemId, setItemId] = useState<string | null>(null);
  const [inventoryId, setInventoryId] = useState<string | null>(null);
  const [subInventoryId, setSubInventoryId] = useState<string | null>('');
  const [showZeroBalance, setShowZeroBalance] = useState<boolean>(false);

  const fetchData = async () => {
    // if (!itemId) {
    //   setError(t('ItemRequired'));
    //   return;
    // }
    setLoading(true);
    setError(null);
    try {
      const { data } = await ntxAPI.get<APIResponse<StockBalance[]>>(`InventoryReports/GetStockBalance`, {
        params: {
          ItemId: itemId,
          InventoryId: inventoryId,
          SubinventoryId: subInventoryId
        }
      });

      if (data.succeeded === true) {
        setData(data.data);
      } else {
        setError(data instanceof Error ? data.message : t('UnknownError'));
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : t('UnknownError'));
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setItemId(null);
    setInventoryId(null);
    setSubInventoryId(null);
  };

  const formatQuantity = (quantity: number): string => {
    return new Intl.NumberFormat('en-US').format(quantity);
  };

  // Filter data based on zero balance toggle
  const filteredData = showZeroBalance ? data : data.filter(item => item.qty > 0);

  // Text direction based on language
  const isRTL = i18n.language === 'ar';
  const textDirection = isRTL ? 'rtl' : 'ltr';

  return (
    <div className='container mt-4' dir={textDirection}>
      <Card>
        <CardHeader className='d-flex justify-content-between align-items-center'>
          <h5 className='mb-0'>{i18n.language === 'en' ? 'Stock Balance Report' : 'تقرير رصيد المخزون'}</h5>
          {data.length > 0 && (
            <div>
              <span className='me-2'>
                {i18n.language === 'en'
                  ? `Showing: ${filteredData.length} of ${data.length} items`
                  : `عرض: ${filteredData.length} من ${data.length} عنصر`}
              </span>
            </div>
          )}
        </CardHeader>

        <CardBody>
          {error && (
            <Alert variant='danger' className='mb-4'>
              {i18n.language === 'en' ? 'Error loading data:' : 'خطأ في تحميل البيانات:'} {error}
            </Alert>
          )}

          {/* Filters Section */}
          <Card className='mb-4'>
            <CardHeader>{i18n.language === 'en' ? 'Filters' : 'الفلاتر'}</CardHeader>
            <Loading loading={loading1 || loading2 || loading3} error={error1 || error2 || error3}>
              <CardBody>
                <Form>
                  <Row className='g-3'>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{t('itemName')}</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable
                          isClearable
                          options={ItemsOptions}
                          onChange={(option: any) => setItemId(option?.value || null)}
                          value={ItemsOptions.find(f => f.value === itemId)}
                          placeholder={t('Choose')}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{t('Inventory')}</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable={true}
                          isClearable
                          options={InventoryOptions}
                          onChange={(option: any) => {
                            setInventoryId(option === null ? null : option.value);
                            setSubInventoryId(null);
                          }}
                          placeholder={t('Choose')}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{t('SubInventory')}</Form.Label>
                        <TreeSelect
                          loading={loading3}
                          showSearch
                          className='w-100'
                          treeLine
                          placeholder={t('Choose')}
                          allowClear
                          treeDefaultExpandAll={false}
                          value={subInventoryId}
                          onChange={(option: any) => {
                            setSubInventoryId(option === null ? null : option);
                          }}
                          treeData={TreeSubInventoryData?.filter(f => f.parentId === inventoryId)}
                          treeNodeFilterProp='title'
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group controlId='zeroBalanceFilter'>
                        <Form.Label>
                          {i18n.language === 'en' ? 'Show Zero Balance' : 'إظهار الأرصدة الصفرية'}
                        </Form.Label>
                        <Form.Check
                          type='switch'
                          checked={showZeroBalance}
                          onChange={e => setShowZeroBalance(e.target.checked)}
                          label={
                            showZeroBalance
                              ? i18n.language === 'en'
                                ? 'Showing all'
                                : 'إظهار الكل'
                              : i18n.language === 'en'
                              ? 'Hiding zero balance'
                              : 'إخفاء الأرصدة الصفرية'
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} className='text-end'>
                      <Button variant='secondary' onClick={resetFilters} className='me-2'>
                        {i18n.language === 'en' ? 'Reset Filters' : 'إعادة تعيين الفلاتر'}
                      </Button>
                      <Button variant='primary' onClick={fetchData} disabled={loading}>
                        {loading ? (
                          <>
                            <Spinner
                              as='span'
                              animation='border'
                              size='sm'
                              role='status'
                              aria-hidden='true'
                              className='me-2'
                            />
                            {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
                          </>
                        ) : i18n.language === 'en' ? (
                          'Load Report'
                        ) : (
                          'تحميل التقرير'
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Loading>
          </Card>

          {/* Summary Cards */}
          {data.length > 0 && (
            <Row className='mb-4'>
              <Col md={3}>
                <Card className='text-center'>
                  <CardBody>
                    <CardTitle>{i18n.language === 'en' ? 'Total Items' : 'إجمالي الأصناف'}</CardTitle>
                    <h3 className='text-primary'>{data.length}</h3>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card className='text-center'>
                  <CardBody>
                    <CardTitle>{i18n.language === 'en' ? 'In Stock Items' : 'الأصناف المتوفرة'}</CardTitle>
                    <h3 className='text-success'>{data.filter(item => item.qty > 0).length}</h3>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card className='text-center'>
                  <CardBody>
                    <CardTitle>{i18n.language === 'en' ? 'Out of Stock' : 'غير متوفر'}</CardTitle>
                    <h3 className='text-danger'>{data.filter(item => item.qty === 0).length}</h3>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card className='text-center'>
                  <CardBody>
                    <CardTitle>{i18n.language === 'en' ? 'Total Quantity' : 'إجمالي الكمية'}</CardTitle>
                    <h3 className='text-info'>{formatQuantity(data.reduce((sum, item) => sum + item.qty, 0))}</h3>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {/* Results Section */}
          {loading ? (
            <div className='text-center my-5'>
              <Spinner animation='border' role='status'>
                <span className='visually-hidden'>{i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}</span>
              </Spinner>
              <p className='mt-2'>
                {i18n.language === 'en' ? 'Loading stock balance data...' : 'جاري تحميل بيانات رصيد المخزون...'}
              </p>
            </div>
          ) : filteredData.length > 0 ? (
            <div className='table-responsive'>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>{i18n.language === 'en' ? 'Item Code' : 'كود الصنف'}</th>
                    <th>{i18n.language === 'en' ? 'Item Name' : 'اسم الصنف'}</th>
                    <th>{i18n.language === 'en' ? 'Inventory' : 'المخزن'}</th>
                    <th>{i18n.language === 'en' ? 'Subinventory' : 'المخزن الفرعي'}</th>
                    <th>{i18n.language === 'en' ? 'UOM' : 'وحدة القياس'}</th>
                    <th>{i18n.language === 'en' ? 'Lot Number' : 'رقم اللوت'}</th>
                    <th>{i18n.language === 'en' ? 'Expiration Date' : 'تاريخ الانتهاء'}</th>
                    <th>{i18n.language === 'en' ? 'Quantity' : 'الكمية'}</th>
                    <th>{i18n.language === 'en' ? 'Status' : 'الحالة'}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item, index) => (
                    <tr key={`${item.itemId}-${item.inventoryId}-${item.subinventoryId}-${index}`}>
                      <td>{item.itemCode}</td>
                      <td>
                        <div>{i18n.language === 'en' ? item.itemName : item.itemName2 || item.itemName}</div>
                        {item.itemName2 && (
                          <div className='text-muted small'>
                            {i18n.language === 'en' ? item.itemName2 : item.itemName}
                          </div>
                        )}
                      </td>
                      <td>
                        <div>
                          {i18n.language === 'en' ? item.inventoryName : item.inventoryName2 || item.inventoryName}
                        </div>
                        {item.inventoryName2 && (
                          <div className='text-muted small'>
                            {i18n.language === 'en' ? item.inventoryName2 : item.inventoryName}
                          </div>
                        )}
                      </td>
                      <td>
                        <div>
                          {i18n.language === 'en'
                            ? item.subinventoryName
                            : item.subinventoryName2 || item.subinventoryName}
                        </div>
                        {item.subinventoryName2 && (
                          <div className='text-muted small'>
                            {i18n.language === 'en' ? item.subinventoryName2 : item.subinventoryName}
                          </div>
                        )}
                      </td>
                      <td>
                        <div>{i18n.language === 'en' ? item.uomName : item.uomName2 || item.uomName}</div>
                        {item.uomName2 && (
                          <div className='text-muted small'>
                            {i18n.language === 'en' ? item.uomName2 : item.uomName}
                          </div>
                        )}
                        <div className='text-muted small'>({item.uomCode})</div>
                      </td>
                      <td>{item.lotNumber || '-'}</td>
                      <td>{item.lotExpirationDate}</td>
                      <td className={`fw-bold ${item.qty > 0 ? 'text-success' : 'text-danger'}`}>
                        {formatQuantity(item.qty)}
                      </td>
                      <td>
                        <Badge bg={item.qty > 0 ? 'success' : 'danger'}>
                          {item.qty > 0
                            ? i18n.language === 'en'
                              ? 'In Stock'
                              : 'متوفر'
                            : i18n.language === 'en'
                            ? 'Out of Stock'
                            : 'غير متوفر'}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className='text-center py-5'>
              <p>
                {i18n.language === 'en'
                  ? 'No data available. Set your filters and click "Load Report" to generate.'
                  : 'لا توجد بيانات متاحة. قم بتعيين الفلاتر الخاصة بك وانقر على "تحميل التقرير" لإنشائه.'}
              </p>
            </div>
          )}
        </CardBody>

        {data.length > 0 && (
          <CardFooter className='text-muted'>
            {i18n.language === 'en'
              ? `Report generated on ${new Date().toLocaleString()}`
              : `تم إنشاء التقرير في ${new Date().toLocaleString()}`}
          </CardFooter>
        )}
      </Card>
    </div>
  );
};

export default StockBalanceReport;
